module.exports = __webpack_public_path__ + "img/zippykind-1.99d7dd94.jpg";